import type { PerformanceOutcome } from "./types";

/**
 * Production success-event sampling rate. Failures, cancellations, and
 * superseded operations are always emitted (100%).
 */
export const PRODUCTION_SUCCESS_SAMPLE_RATE = 0.1;

let productionSuccessEventCounter = 0;

/**
 * Pure sample gate for the nth production success event (1-indexed).
 * Exported for deterministic tests without resetting module state.
 */
export function isNthProductionSuccessSampled(
  successEventIndex: number,
  rate: number = PRODUCTION_SUCCESS_SAMPLE_RATE,
): boolean {
  if (rate >= 1) {
    return true;
  }
  if (rate <= 0) {
    return false;
  }
  const period = Math.max(1, Math.round(1 / rate));
  return successEventIndex % period === 0;
}

export function shouldSamplePerformanceEvent(
  outcome: PerformanceOutcome,
  environment: string,
): boolean {
  if (outcome !== "success") {
    return true;
  }

  if (environment === "production") {
    productionSuccessEventCounter += 1;
    return isNthProductionSuccessSampled(productionSuccessEventCounter);
  }

  // QA, development, ephemeral, and unknown environments: emit all successes
  // so dashboards and tests stay fully populated.
  return true;
}
